export default "__VITE_ASSET__CkH_7ZoX__"